var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChooseAllShopLocations = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40.539,
    height: 39.348,
    viewBox: "0 0 40.539 39.348",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-init",
    x1: 0.061,
    y1: 0.15,
    x2: 0.939,
    y2: 0.718,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dee1ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95A1B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-secondary",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient-init"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35602",
    "data-name": "Group 35602",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8841",
    d: "M-19652.469-22011.9h-10.611a71.507,71.507,0,0,1-4.65,7.035,71.859,71.859,0,0,1-4.65-7.035h-10.611l-5.008,14.309h40.539Z",
    transform: "translate(19688 22036.941)",
    fill: "#dde0eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842",
    d: "M-19669.27-22032.9a10.66,10.66,0,0,0-10.73,10.611c-.119,10.135,10.73,22.771,10.73,22.771s10.85-12.637,10.73-22.771A10.66,10.66,0,0,0-19669.27-22032.9Z",
    transform: "translate(19689.539 22032.9)",
    fill: "url(#linear-gradient-init)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842-2",
    d: "M-19657.23-22017.9c-2.623,0-4.77,2.385-4.77,5.367,0,5.127,4.77,11.326,4.77,11.326s4.77-6.32,4.77-11.326C-19652.461-22015.518-19654.609-22017.9-19657.23-22017.9Z",
    transform: "translate(19693 22035.787)",
    fill: "url(#linear-gradient-secondary)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8842-3",
    d: "M-19683.23-22017.9c-2.623,0-4.77,2.385-4.77,5.367,0,5.127,4.77,11.326,4.77,11.326s4.77-6.32,4.77-11.326C-19678.461-22015.518-19680.609-22017.9-19683.23-22017.9Z",
    transform: "translate(19688 22035.787)",
    fill: "url(#linear-gradient-secondary)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7125",
    "data-name": "Ellipse 7125",
    cx: 1.788,
    cy: 1.788,
    r: 1.788,
    transform: "translate(2.981 21.517)",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7126",
    "data-name": "Ellipse 7126",
    cx: 1.788,
    cy: 1.788,
    r: 1.788,
    transform: "translate(33.981 21.517)",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7127",
    "data-name": "Ellipse 7127",
    cx: 5.365,
    cy: 5.365,
    r: 5.365,
    transform: "translate(14.904 6.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7128",
    "data-name": "Ellipse 7128",
    cx: 1.788,
    cy: 1.788,
    r: 1.788,
    transform: "translate(18.481 9.594)",
    fill: "#95A1B2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChooseAllShopLocations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/choose-all-shop-locations.3c60515d.svg";
export { ForwardRef as ReactComponent };